exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.UploadImagePathDialog_Container[data-v-dd0df900] {\n  margin-top: 10px;\n}\n.UploadImagePathDialog_PathContainer[data-v-dd0df900] {\n  display: inline-block;\n}\n", ""]);

// exports
